import React, { Component } from "react";
import {
  fetchAllResults,
  fetchDrivers,
  changeStep
} from "../../modules/results/actions";
import { changeLanguage } from "../../modules/preference/actions";
import { Button } from "antd";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import FrontPage from "./index";
import { connect } from "react-redux";

class frontPageContainer extends Component {
  componentWillMount() {
    this.props.fetchAllResults();
  }

  render() {
    if (!this.props.user || this.props.match.params.id !== this.props.user.uid) {
      return (
        <div className="noAccessContainer">
          <div>
            <div>You don't have access</div>
            <div>
              <Link to="/">
                <Button>Go back to website</Button>
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        {Object.keys(this.props.surveys).length ? (
          <FrontPage {...this.props} />
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    language: state.preference.language,
    surveys: state.results.resultsMap,
    drivers: state.results.drivers
  };
}

const mapActionToProps = {
  changeLanguage,
  fetchAllResults,
  fetchDrivers,
  changeStep
};

export default connect(
  mapStateToProps,
  mapActionToProps
)(frontPageContainer);



// WEBPACK FOOTER //
// ./src/pages/FrontPage/container.js